
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '未経験でも大丈夫ですか？',
      answer: 'はい、未経験の方でも大歓迎です。入店前に丁寧な研修を行い、施術の基本から接客マナーまでしっかりサポートします。先輩セラピストも優しくフォローしますので、安心してスタートできます。'
    },
    {
      question: '週にどれくらい働けばいいですか？',
      answer: '完全自由シフト制なので、週1日からでもOKです。あなたのライフスタイルに合わせて、無理なく働ける日数・時間を選べます。学業やプライベートとの両立も可能です。'
    },
    {
      question: '本当に安全ですか？',
      answer: '個室型の店舗で、出張型ではありませんので、セラピストの安全を最優先に考えています。また、24時間体制でスタッフがサポートし、何かあればすぐに対応できる体制を整えています。'
    },
    {
      question: 'どれくらい稼げますか？',
      answer: '完全歩合制で、バック率は50%〜70%です。頑張り次第で日給20,000円〜50,000円以上も可能です。実際に月収50万円以上稼いでいるセラピストも多数在籍しています。'
    },
    {
      question: '面接時に必要なものはありますか？',
      answer: '身分証明書（運転免許証、パスポート、マイナンバーカードなど）をご持参ください。服装は自由ですが、清潔感のある服装でお越しください。履歴書は不要です。'
    },
    {
      question: '他の人にバレないか心配です',
      answer: '完全個室制で、他のセラピストやお客様と顔を合わせることはほとんどありません。また、源泉徴収票などの書類も店舗名が記載されないよう配慮しています。プライバシー保護を徹底しています。'
    }
  ];

  return (
    <section id="faq" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-pink-50/30">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block text-pink-500 font-bold text-sm mb-3 tracking-wider">FAQ</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4">
            よくある質問
          </h2>
          <p className="text-gray-600 text-base">
            応募前の不安や疑問にお答えします
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-pink-100 overflow-hidden hover:shadow-lg transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-pink-50/50 transition-colors"
              >
                <span className="font-bold text-gray-800 text-base pr-4">{faq.question}</span>
                <div className={`w-8 h-8 flex items-center justify-center bg-pink-100 rounded-full flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-xl text-pink-500"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5 pt-2">
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
